import Tab, { TabProps } from '@mui/material/Tab';
import { styled } from '@mui/material/styles';


const StyledTab = styled(Tab)<TabProps>(({ theme }) => ({
	  color: 'var(--Schemes-On-Surface)',
    padding: "8px 12px",
    width: "331px",
    marginBottom: "16px",
    "&.Mui-selected": {
      color: 'var(--Schemes-On-Surface)',
			backgroundColor: 'var(--Schemes-Secondary-Container)',
    },
}))

export default StyledTab